import React from 'react'
import {LoggerProps, withLogger} from './withLogger'
import {withPageTitle} from './withPageTitle'
import {withScroller} from './withScroller'
import {withLoadingSpinner} from './withLoadingSpinner'
import EventEmitterExResident from '../pageBaseComponents/EventEmitterExResident'
import {AsyncCommunicationProps, withAsyncCommunication} from './withAsyncCommunication'
import {withGuestPageTemplate} from './withGuestPageTemplate'
import {RouterPageProps} from '../RouterPropsInjector'

export type GuestWithErrorHandlingPagePropsSet =
    LoggerProps &
    AsyncCommunicationProps &
    RouterPageProps &
    { eventEmitter: EventEmitterExResident }

export const createGuestWithErrorHandlingPage = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & GuestWithErrorHandlingPagePropsSet>,
) =>
    withLogger(
        WrappedComponent.displayName || 'undefined',
        withGuestPageTemplate(withScroller(
            withAsyncCommunication(
                withPageTitle(
                    withLoadingSpinner(
                        WrappedComponent)))))
        ,
    )
